/* Cart drawer: "was removed" + Undo, and Save for later (Wade 2026-09-19). Moved out of snippets/fe-drawer-save-later.liquid
   by Round 1 decision #23 (javascript-10, Wade 2026-10-13) so it is cached instead of re-sent in every page; the snippet
   keeps the styles and loads this file with defer. How it works: see the comment at the top of that snippet.
   2026-10-22: "Save for later" parks the line on the WISHLIST (assets/fe-wishlist.js, as a saved cart line) instead of
   this browser's localStorage, so it follows the shopper to another device after login and shows on the wishlist page.
   The strip lists the lines saved from the cart (FEWishlist.cartLines); markup, labels and buttons are unchanged.
   Regression fixes the same day: the line leaves the cart only once the save has worked (a failure keeps it in the cart
   with a message); Move to cart and Remove update the strip at once; the strip is built when the drawer opens, not on
   every page load. Second round: the strip opens drawn from the last-known lines (FEWishlist.cartLinesNow, no network),
   then refreshes; a line being saved for later joins the strip only once it has left the cart; a moved line whose
   removal from the list fails stays out of the strip (fe-wishlist.js retries it). Round 4: each Save for later holds
   only its own row out of the strip until its own line has left the cart (several saves, unrelated redraws and the
   fallback timer no longer release one another); strip buttons act on the line drawn under them; only the newest
   strip load draws. Round 5: the save acts on the line as it is in the drawer when the save comes back (the drawer
   may have been redrawn meanwhile), and a held row counts neither in the strip nor in "See everything you saved".
   Wade 2026-10-22 (after trying staging): Save for later takes the line out of the cart at once, as the
   old browser-only strip did, and the wishlist save runs behind it; if that save fails the ring goes
   back into the cart with a notice. */
  (function () {
    if (window.__feDrawerSaveLater) return;
    window.__feDrawerSaveLater = true;
    var notices = [], busy = false, skipNotice = false;
    var holds = [];  /* Save for later under way: { cartKey, rowKey, clicked, timer } */
    var shown = [];  /* the lines as drawn, in order: what each strip button acts on */
    var seq = 0;     /* only the newest strip load draws */
    var saved = { lines: [], total: 0, more: 0, url: '/apps/wishlist' }, loaded = false;

    function drawer() { return document.getElementById('cart-drawer'); }
    function isOpen() { var d = drawer(); return !!(d && d.hasAttribute('open')); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
    function wl() { return window.FEWishlist || null; }
    function dataOf(row) {
      try {
        var d = JSON.parse(row.querySelector('.fe-li-data').textContent);
        /* Liquid's json filter prints line item properties as [[name, value], ...] with the text HTML-escaped
           ("J &amp; M"); the cart API wants {name: value} with the shopper's real characters */
        if (Array.isArray(d.properties)) {
          var o = {}, ta = document.createElement('textarea');
          var plain = function (s) { ta.innerHTML = String(s); return ta.value; };
          d.properties.forEach(function (p) { if (p && p[0] != null && p[1] !== '' && p[1] != null) o[plain(p[0])] = plain(p[1]); });
          d.properties = o;
        }
        return d;
      } catch (e) { return null; }
    }
    /* 2026-10-15: not the Perfect Fit Promise rows (snippets/fe-pfp-line.liquid); they leave with their ring */
    function rows() { var d = drawer(); return d ? Array.prototype.slice.call(d.querySelectorAll('line-item-quantity[data-key]:not(.fe-pfp-li-wrap)')) : []; }

    /* text: what happened to the ring ("was removed." + Undo by default). keep: a plain notice that stays
       while the ring is in the cart (a failed save that put it back) and goes away on its own. */
    function noticeNode(d, text, keep) {
      var n = document.createElement('div');
      n.className = 'fe-dremoved';
      n.setAttribute('role', 'status');
      /* one line at any width: the title gives way (CSS ellipsis), "was removed." and Undo never wrap */
      n.innerHTML = '<span><a href="' + esc(d.url) + '">' + esc(d.title) + '</a><i>' + esc(text || 'was removed.') + '</i></span>' +
        (keep ? '' : '<button type="button" class="fe-dundo">Undo</button>');
      n._d = d;
      n._keep = !!keep;
      if (keep) setTimeout(function () { notices = notices.filter(function (x) { return x !== n; }); n.remove(); }, 8000);
      return n;
    }

    /* the wishlist is the source; this keeps a rendered copy of the saved cart lines */
    function excludeHeld() {
      var held = {};
      holds.forEach(function (h) { if (h.rowKey) held[h.rowKey] = 1; });
      var before = saved.lines.length;
      saved.lines = saved.lines.filter(function (l) { return !held[l.key]; });
      /* a held row is not on screen yet: it is not counted in the total behind "See everything" either */
      saved.total = Math.max(0, saved.total - (before - saved.lines.length));
      saved.more = Math.max(0, saved.total - saved.lines.length);
    }
    function now() { var w = wl(); if (w && w.cartLinesNow) { saved = w.cartLinesNow(20); excludeHeld(); } return saved; }
    function load() {
      var w = wl();
      if (!w) return Promise.resolve(saved);
      var mine = ++seq;
      return w.cartLines(20).then(function (r) { if (mine === seq) { saved = r; excludeHeld(); loaded = true; } return saved; }).catch(function () { return saved; });
    }
    /* a save's line has left the cart (or the fallback fired): its row may show in the strip now */
    function release(h) {
      var i = holds.indexOf(h);
      if (i === -1) return;
      holds.splice(i, 1);
      clearTimeout(h.timer);
      now(); place(); refresh();
    }

    function place() {
      var d = drawer();
      if (!d) return;
      var live = rows();
      /* a notice whose ring is still in the cart means the change failed: drop it */
      notices = notices.filter(function (n) { return n._keep || !live.some(function (r) { return r.getAttribute('data-key') === n._d.key; }); });
      var end = d.querySelector('.fe-dremoved-slot');
      notices.forEach(function (n) {
        var anchor = null;
        live.forEach(function (r) { if (!anchor && r.getAttribute('data-key') === n._before) anchor = r; });
        if (anchor) anchor.parentNode.insertBefore(n, anchor);
        else if (end) end.appendChild(n);
      });
      var box = d.querySelector('.fe-dsaved-slot');
      if (!box) return;
      var list = saved.lines;
      shown = list.slice();
      /* the empty drawer is vertically centered by the theme; with removed lines or saved rings in it the content
         outgrows the panel and slides under the header, so it goes back to a normal top-down scroll */
      var extras = !!d.querySelector('.fe-empty') && (notices.length > 0 || list.length > 0);
      d.classList.toggle('fe-has-extras', extras);
      /* Wade 2026-09-19: empty cart + a saved ring = Move to cart is THE action, so it takes the loud navy and
         Continue shopping steps down to the quiet button (one loud button per view). With rings still in the
         cart, Checkout is the loud one and Move to cart stays quiet. */
      d.classList.toggle('fe-empty-saved', !!d.querySelector('.fe-empty') && list.length > 0);
      if (d.querySelector('.fe-empty')) d.classList.toggle('drawer--center-body', !extras);
      if (!list.length) { box.innerHTML = ''; return; }
      box.innerHTML = '<div class="fe-dsaved"><h3 class="fe-dsaved__h">Saved for later <span>(' + list.length + ')</span></h3>' +
        list.map(function (s, i) {
          var opts = [];
          if (s.variant) String(s.variant).split(' · ').forEach(function (v) { opts.push(v); });
          var props = Array.isArray(s.properties) ? {} : (s.properties || {});
          /* Wade 2026-10-03: same labels as the cart lines - couples sets list Size + Engraving under "His ring" /
             "Her ring" headings, other rings show "Engraving"; the "Add Engraving?: Yes" row is dropped once
             engraving text is shown */
          var fp = props, fhis = [], fher = [];
          var ftext = Object.keys(fp).some(function (k) { return /engrav/i.test(k) && fp[k] && !/^(yes|no)$/i.test(String(fp[k]).trim()); });
          Object.keys(fp).forEach(function (k) {
            var v = fp[k];
            if (k.charAt(0) === '_' || !v) return;
            var eng = /engrav/i.test(k), yn = /^(yes|no)$/i.test(String(v).trim());
            if (eng && yn && ftext) return;
            var m = /^(his|her) /i.exec(k);
            var label = eng && !yn ? 'Engraving' : (m && /size/i.test(k) ? 'Size' : '');
            if (!m) { opts.push((label || k) + ': ' + v); return; }
            (m[1].toLowerCase() === 'his' ? fhis : fher).push((label || k.slice(4)) + ': ' + v);
          });
          /* Wade 2026-10-07: his / her as colour cards, the same markup the Liquid line items render */
          var fgrp = function (h, rows) {
            if (!rows.length) return '';
            var who = /^his/i.test(h) ? 'HIS' : 'HER', size = '', rest = [];
            rows.forEach(function (o) { var m = /^Size:\s*(.+)$/.exec(o); if (m && !size) size = m[1]; else rest.push(o); });
            return '<div class="fe-hh' + (who === 'HER' ? ' fe-hh--her' : '') + '"><div class="fe-hh__head"><span class="fe-hh__chip">' + who + '</span><span>' + (size ? 'Size ' + esc(size) : 'ring') + '</span></div>' +
              (rest.length ? '<ul class="fe-hh__opts">' + rest.map(function (o) { return '<li>' + esc(o) + '</li>'; }).join('') + '</ul>' : '') + '</div>';
          };
          return '<div class="fe-dsaved__item" data-i="' + i + '">' +
            '<a class="fe-dsaved__img" href="' + esc(s.url) + '">' + (s.image ? '<img src="' + esc(s.image) + '" alt="' + esc(s.title) + '" loading="lazy" width="60" height="60">' : '') + '</a>' +
            '<div class="fe-dsaved__info"><a class="fe-dsaved__t" href="' + esc(s.url) + '">' + esc(s.title) + '</a>' +
            '<div class="fe-dsaved__p">' + esc(s.price) + '</div>' +
            (opts.length ? '<ul class="fe-li__opts">' + opts.map(function (o) { return '<li>' + esc(o) + '</li>'; }).join('') + '</ul>' : '') + fgrp('His ring', fhis) + fgrp('Her ring', fher) +
            (s.pfp ? '<ul class="fe-li__opts"><li>With the Perfect Fit Promise</li></ul>' : '') +
            '<div class="fe-dsaved__msg" role="alert" hidden></div>' +
            '<div class="fe-li__actions"><button type="button" class="fe-dsaved__move">Move to cart</button>' +
            '<button type="button" class="fe-dsaved__del fe-li__later" style="color:var(--fe-faint)" aria-label="Remove ' + esc(s.title) + ' from saved for later">Remove</button></div>' +
            '</div></div>';
        }).join('') +
        (saved.more > 0 ? '<a class="fe-dsaved__all" href="' + esc(saved.url) + '">See everything you saved (' + saved.total + ')</a>' : '') +
        '</div>';
    }
    /* drop one saved line from the strip at once (the server call runs behind it) */
    function dropLocal(line) {
      saved.lines = saved.lines.filter(function (x) { return x.key !== line.key; });
      saved.total = Math.max(0, saved.total - 1);
      saved.more = Math.max(0, saved.total - saved.lines.length);
    }

    /* add the ring back, then hand the theme a normal cart:change (with its bundled sections) */
    function add(d) {
      var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      return fetch(root + 'cart/add.js', { method: 'POST', headers: json,
        /* 2026-10-15: a ring that had the Perfect Fit Promise gets it back, nested under it again */
        body: JSON.stringify({ items: [{ id: d.id, quantity: d.quantity || 1, properties: d.properties || {} }]
          .concat(d.pfp ? [{ id: d.pfp, quantity: d.quantity || 1, parent_id: d.id }] : []) })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'This ring is no longer available.'); });
        var sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
        return fetch(root + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ sections: sections.join(',') }) });
      }).then(function (r) { return r.json(); });
    }
    function announce(cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: cart } }));
    }
    /* what the wishlist keeps for a cart line: its variant, quantity, engraving, and the Perfect Fit Promise flag */
    function wishlistItemFor(d) {
      var props = {};
      Object.keys(d.properties || {}).forEach(function (k) { if (d.properties[k] != null && d.properties[k] !== '') props[k] = String(d.properties[k]); });
      if (d.pfp) props.__pfp = String(d.pfp);
      return { product_id: d.product_id, handle: d.handle, variant_id: d.id, source: 'cart', quantity: Math.max(1, Number(d.quantity) || 1), properties: Object.keys(props).length ? props : undefined };
    }
    function rowError(row, text) {
      var box = row.querySelector('.fe-li__actions') || row;
      var m = row.querySelector('.fe-li__err');
      if (!m) { m = document.createElement('p'); m.className = 'fe-li__err'; m.setAttribute('role', 'alert'); box.parentNode.insertBefore(m, box.nextSibling); }
      m.textContent = text;
    }

    document.addEventListener('click', function (e) {
      var d = drawer();
      if (!d || !d.contains(e.target)) return;
      var t = e.target.closest('.fe-li__remove, .quantity-selector__button[href$="quantity=0"], .fe-li__later, .fe-dundo, .fe-dsaved__move');
      if (!t) return;

      if (t.matches('.fe-li__remove, .quantity-selector__button')) {
        /* the theme performs the removal (Remove, or minus at quantity 1); this only remembers what stood here */
        var row = t.closest('line-item-quantity[data-key]');
        var data = row && dataOf(row);
        if (data && !skipNotice) {
          var n = noticeNode(data), all = rows(), next = all[all.indexOf(row) + 1];
          n._before = next ? next.getAttribute('data-key') : null;
          notices.push(n);
        }
        skipNotice = false;
        return;
      }
      e.preventDefault();

      if (t.classList.contains('fe-dsaved__del')) {
        var s0 = shown[+t.closest('.fe-dsaved__item').getAttribute('data-i')];
        if (!s0) return;
        dropLocal(s0);
        place();
        if (wl()) wl().removeLine(s0.key).catch(function () { load().then(place); });
        return;
      }
      if (t.classList.contains('fe-li__later')) {
        var r2 = t.closest('line-item-quantity[data-key]');
        var d2 = r2 && dataOf(r2);
        if (!d2 || busy) return;
        if (!wl() || !d2.product_id) { rowError(r2, 'Save for later is not available right now. Please try again.'); return; }
        var del = r2.querySelector('.fe-li__remove');
        if (!del) return;
        /* the line leaves the cart at once (the theme's own removal) and the wishlist save runs behind it;
           the row joins the strip once the line has left the cart (cart-drawer:refreshed) and the save
           has answered, so it is never on screen twice with a live Move to cart */
        var h = { cartKey: r2.getAttribute('data-key'), rowKey: null, clicked: true, timer: null };
        holds.push(h);
        h.timer = setTimeout(function () { release(h); }, 6000);
        skipNotice = true;
        del.click();
        skipNotice = false; /* never left over for a later Remove */
        wl().add(wishlistItemFor(d2), { view: d2, onSaved: function (row) { h.rowKey = row.key; } }).catch(function () {
          /* the save did not happen: the ring goes back into the cart, and the drawer says so */
          release(h);
          return add(d2).then(function (cart) {
            notices.push(noticeNode(d2, 'is back in your cart: it could not be saved for later.', true));
            announce(cart);
          }).catch(function () {
            /* it could not even go back by itself: the usual "was removed" line with Undo */
            var n = noticeNode(d2); n._before = null; notices.push(n); place();
          });
        });
        return;
      }

      if (busy) return;
      busy = true;
      t.style.opacity = '0.4';
      var undo = t.classList.contains('fe-dundo');
      var holder = undo ? t.closest('.fe-dremoved') : t.closest('.fe-dsaved__item');
      var item = undo ? holder._d : shown[+holder.getAttribute('data-i')];
      if (!item) { busy = false; return; }
      add(item).then(function (cart) {
        /* settle the books BEFORE the theme redraws the drawer (its redraw can finish within the same tick) */
        if (undo) { notices = notices.filter(function (n) { return n !== holder; }); holder.remove(); }
        else { dropLocal(item); if (wl()) wl().removeLine(item.key, { moved: true }).catch(function () {}); }
        busy = false;
        announce(cart);
      }).catch(function (err) {
        busy = false;
        t.style.opacity = '';
        var m = undo ? holder.querySelector('span') : holder.querySelector('.fe-dsaved__msg');
        if (m) { m.hidden = false; m.style.display = 'block'; m.style.whiteSpace = 'normal'; m.textContent = err.message; }
      });
    }, true);

    /* When the drawer empties, the theme fades its pinned footer out (opacity 0, 30px down) and only ever fades it back in
       when the drawer OPENS. Undo / Move to cart refill a drawer that is already open - a path the stock theme never
       takes - so the footer (Checkout, express checkout, the whole sticky bar) stayed invisible. Bring it back here. */
    function wakeFooter() {
      var d = drawer();
      var foot = d && d.shadowRoot && d.shadowRoot.querySelector('[part="footer"]');
      if (!foot || d.querySelector('.fe-empty') || !d.hasAttribute('open')) return;
      if (getComputedStyle(foot).opacity === '1' && foot.style.transform.indexOf('30px') === -1) return;
      if (foot.getAnimations) foot.getAnimations().forEach(function (a) { a.cancel(); });
      foot.style.opacity = '1';
      foot.style.transform = 'translateY(0px)';
      if (foot.animate) foot.animate({ opacity: [0, 1], transform: ['translateY(30px)', 'translateY(0px)'] }, { duration: 250, easing: 'cubic-bezier(.25,.46,.45,.94)' });
    }
    function refresh() { return load().then(place); }
    /* the strip is built when the drawer opens (it can have changed on the cart page, the wishlist page or in
       another tab), and rebuilt while it is open; a page where the drawer never opens makes no requests for it */
    document.addEventListener('cart-drawer:refreshed', function () {
      now(); place(); wakeFooter();
      /* release only the saves whose own line is no longer in the cart */
      var inCart = {};
      rows().forEach(function (r) { inCart[r.getAttribute('data-key')] = 1; });
      holds.slice().forEach(function (h) { if (h.clicked && !inCart[h.cartKey]) release(h); });
    });
    document.addEventListener('fe:wishlist:change', function () {
      if (isOpen()) { now(); place(); refresh(); } else loaded = false;
    });
    function bind() { var d = drawer(); if (d) d.addEventListener('dialog:before-show', function () { now(); place(); refresh(); }); now(); place(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  })();
